"use client";

import { useEffect, useRef } from "react";

export default function NetworkField() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;

    if (!canvas) {
      return;
    }

    let cancelled = false;
    let dispose: (() => void) | undefined;
    let idleId = 0;
    let timeoutId = 0;

    function start(target: HTMLCanvasElement) {
      import("./engine")
        .then(({ createNetwork }) => {
          if (cancelled || !target.isConnected) {
            return;
          }

          try {
            dispose = createNetwork(target);
          } catch {
            return;
          }

          if (cancelled) {
            dispose();
          }
        })
        .catch(() => undefined);
    }

    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(() => start(canvas), { timeout: 2000 });
    } else {
      timeoutId = window.setTimeout(() => start(canvas), 200);
    }

    return () => {
      cancelled = true;
      window.cancelIdleCallback?.(idleId);
      window.clearTimeout(timeoutId);
      dispose?.();
    };
  }, []);

  return (
    <div className="fixed inset-0 z-0">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_78%_48%,rgba(87,242,168,0.09),transparent_62%)]"
        aria-hidden
      />
      <canvas
        ref={canvasRef}
        className="absolute inset-0 h-full w-full cursor-grab active:cursor-grabbing"
        aria-hidden
      />
    </div>
  );
}
